import { render, staticRenderFns } from "./credit-note-editor.vue?vue&type=template&id=60890190&scoped=true&"
import script from "./credit-note-editor.vue?vue&type=script&lang=js&"
export * from "./credit-note-editor.vue?vue&type=script&lang=js&"
import style0 from "./credit-note-editor.vue?vue&type=style&index=0&id=60890190&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60890190",
  null
  
)

export default component.exports